var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('i',{staticClass:"gf-icon gf-icon-git-commit text-secondary mr-1"}),_c('a',{staticClass:"text-truncate",attrs:{"href":'/project/' + _vm.userAlias + '/' + _vm.projectAlias + '/commit/' + _vm.hash}},[_vm._v(" "+_vm._s(_vm._f("cutCommitHash")(_vm.hash))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }